<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Registrations / Institutions' | translate}}
            <span (click)="switchHeadings()"
                  class="addBtn services-icon--add ml-2"
                  style="position:relative;top:-5px;">{{'Turn Table' | translate}}</span>
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <section class="table-container cross-table-container">
                    <section class="table-flip-scroll">
                        <table class="table table-bordered table-striped cross-table">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <ng-container *ngFor="let column of institutionRegistrationRelations[0]; let i = index;">
                                        <th *ngIf="column">
                                            <span *ngIf="!tableSwitched"
                                                  class="limited"
                                                  title="{{column?.institutionName}}">
                                                {{column?.institutionShortName}}
                                            </span>
                                            <span *ngIf="tableSwitched"
                                                  class="limited"
                                                  title="{{column?.registrationName}}">
                                                {{column?.registrationShortName && column?.registrationShortName !== "" ? column?.registrationShortName : column?.registrationName}}
                                            </span>
                                        </th>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let row of institutionRegistrationRelations; let i = index;">
                                    <tr *ngIf="row[0]">
                                        <td *ngIf="!tableSwitched">
                                            <span class="limited wider" title="{{row[0]?.registrationName}}">
                                                {{row[0]?.registrationShortName && row[0]?.registrationShortName !== "" ? row[0]?.registrationShortName : row[0]?.registrationName}}
                                            </span>
                                        </td>
                                        <td *ngIf="tableSwitched">
                                            <span class="limited wider" title="{{row[0]?.institutionName}}">{{row[0]?.institutionShortName}}</span>
                                        </td>
                                        <ng-container *ngFor="let col of row; let j = index;">
                                            <td *ngIf="col">
                                                <i class="fas {{ col?.registrationHasInstitution ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-off toggle-disabled' }}"
                                                   style="cursor:pointer;"
                                                   (click)="editInstitutionRegistration(col)"></i>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </section>
                </section>
            </div>
        </div>
    </div>
</app-service-detail>